import { trendsService } from "../../../services/api/trends.endpoints";
import { setDisplayErrorSnackBar } from "../../../features/userSlice";
import store from "../../../store";
import {
  setActivityNotesDataGlobal,
  setFilterBizLayerQueryDataById,
  setGeoData,
  setOrganizationOptions,
  setTrafficSourceData,
} from "../../../features/trendsSlice";

async function getDimentions(oauthTokenHeader: string) {
  try {
    const response = await trendsService.getDimentions(oauthTokenHeader);
    if (!response.status || response.status !== 200) {
      throw new Error();
    } else {
      store.dispatch(setOrganizationOptions(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}
async function getTrafficSourcesTrends(oauthTokenHeader: string) {
  try {
    const response = await trendsService.getTrafficSourcesTrends(
      oauthTokenHeader
    );
    if (!response.status || response.status !== 200) {
      throw new Error();
    } else {
      store.dispatch(setTrafficSourceData(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}
async function getGeosTrends(oauthTokenHeader: string) {
  try {
    const response = await trendsService.getGeosTrends(oauthTokenHeader);
    if (!response.status || response.status !== 200) {
      throw new Error();
    } else {
      store.dispatch(setGeoData(response?.data?.data));
    }
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Unknown error occurred",
        type: "error",
      })
    );
  }
}
async function getFilterBizLayerQueryTrends({
  queryId,
  oauthTokenHeader,
  type,
  key,
  websiteSharedUids = [],
  dimensions = [],
  trafficSource,
  account_shared_uid,
  campaign_status,
}: {
  queryId: any;
  oauthTokenHeader: any;
  type: any;
  key: any;
  websiteSharedUids: any[];
  dimensions: any[];
  trafficSource: any;
  account_shared_uid?: any;
  campaign_status?: any;
}) {
  try {
    const response = await trendsService.getFilterBizLayerQueryTrends(
      queryId,
      oauthTokenHeader,
      type,
      websiteSharedUids,
      dimensions,
      trafficSource,
      account_shared_uid,
      campaign_status
    );

    if (!response.status || response.status !== 200) {
      throw new Error();
    }

    store.dispatch(
      setFilterBizLayerQueryDataById({
        key,
        data: response?.data?.data || [],
      })
    );
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message:
          e?.parsedText ||
          "Failed to fetch filter options. Please try again later or Refresh the page.",
        type: "error",
      })
    );
  }
}

async function getActivityNotes({
  oauthTokenHeader,
  websiteSharedUid,
  fromDate,
  toDate,
}: {
  oauthTokenHeader: string;
  websiteSharedUid: any;
  fromDate: string;
  toDate: string;
}) {
  try {
    const response = await trendsService.getActivityNotes(
      oauthTokenHeader,
      websiteSharedUid,
      fromDate,
      toDate
    );
    if (response.status === 204) {
      store.dispatch(
        setDisplayErrorSnackBar({
          message: "",
          type: "warning",
        })
      );
      return;
    }
    if (!response.status || response.status !== 200) {
      throw new Error();
    }

    store.dispatch(
      setActivityNotesDataGlobal(
        Object.values(response?.data?.data || {}).flat()
      )
    );
  } catch (e: any) {
    store.dispatch(
      setDisplayErrorSnackBar({
        message: e?.parsedText || "Failed to load activity notes",
        type: "error",
      })
    );
  }
}

export const TrendsDashboardEndPointLogic = {
  getDimentions,
  getFilterBizLayerQueryTrends,
  getTrafficSourcesTrends,
  getGeosTrends,
  getActivityNotes,
};
